import { useDispatch } from 'react-redux';
import FJImageInput from '../../../../common/components/FJImageInput/FJImageInput';
import useLocalStore from '../../../../hooks/useLocalStore';
import { useSelector } from 'react-redux';
import { setSliceIsDraggingFileAction } from '../../../../redux/slices/FJSliceCommon';
import FJActionImageExtender from '../../../../redux/action/FJActionImageExtender';
import {
    UPLOAD_FILE_TYPE_IMAGE_EXTENDER,
    CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
    UPLOAD_FILE_TYPE_NO_GIF,
    UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE,
} from '../../../../config/dataConfig/FJGenerateData';
import FJConstant from '../../../../constants/FJConstant';
import FJActionEditPage from '../../../../redux/action/FJActionEditPage.js';

const FJImageExtenderImageUploadContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();

    const isDraggingFile = useSelector(state => state.common.isDraggingFile);
    const uploadImageInfo = useSelector(state => state.imageExtender.uploadImageInfo);
    const taskStatus = useSelector(state => state.common.taskStatus);

    const uploadImg = file => {
        if (taskStatus !== FJConstant.DEFAULT) {
            return;
        }
        dispatch(FJActionImageExtender.uploadImageAction(file));
    };

    const _setIsDraggingFile = value => {
        if (taskStatus !== FJConstant.DEFAULT) {
            return;
        }
        dispatch(setSliceIsDraggingFileAction(value));
    };

    const _openMediaLibrary = () => {
        dispatch(
            FJActionEditPage.openMediaLibraryAction({
                uploadConfig: {
                    isMultiple: false,
                    maxMediaNum: 1,
                    selectedMediaIds: [],
                    acceptTypeWithTranscode:
                        UPLOAD_FILE_TYPE_IMAGE_EXTENDER + CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
                    acceptTypeNoTranscode: UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE,
                    suffixTranscode: CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
                    // 媒体库的过滤规则
                    mediaFilterFunc: item => {
                        const mediaTypes = ['IMAGE'];
                        return mediaTypes.includes(item.type);
                    },
                    // 上传文件之后返回的数据
                    callbackOptions: {},
                },
            }),
        );
    };

    return (
        <FJImageInput
            setIsDraggingFile={_setIsDraggingFile}
            uploadImg={uploadImg}
            openMediaLibrary={_openMediaLibrary}
            isDraggingFile={isDraggingFile}
            uploadImageInfo={uploadImageInfo}
            acceptFile={UPLOAD_FILE_TYPE_IMAGE_EXTENDER + CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES}
            disable={taskStatus !== FJConstant.DEFAULT}
        />
    );
};

export default FJImageExtenderImageUploadContainer;
